import { useEffect, useState } from "react";
import MobileMenu from "./MobileMenu";

export default function Navbar() {
  const [menus, setMenus] = useState([]);
  const [active, setActive] = useState(null);
  const [mobile, setMobile] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Fetch menus
  useEffect(() => {
    fetch("/api/menus/")
      .then((res) => res.json())
      .then(setMenus);
  }, []);

  // Scroll listener
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const activeMenu = menus.find((m) => m.id === active);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-colors duration-300 ${
        scrolled ? "bg-green-950/90 shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto flex justify-between items-center h-16 px-6">
        {/* Logo */}
        <div className="flex items-center">
          <a href="/" className="transition-opacity hover:opacity-80">
            <img 
              src="/logo.png" 
              alt="SecuWall Logo" 
              className="h-10 w-auto object-contain" 
            />
          </a>
        </div>
                {/* Desktop Menu */}
        <div
          className="hidden md:flex space-x-8 h-full items-center" // Added h-full
          onMouseLeave={() => setActive(null)}
        >
          {menus.map((menu) => (
            <button
              key={menu.id}
              onMouseEnter={() => setActive(menu.id)}
              className="text-white hover:text-accent transition-colors h-full px-2" // Added h-full
            >
              {menu.title}
            </button>
          ))}
        </div>

        {/* CTA */}
        <div className="hidden md:block">
          <a href="/#contact-us">
            <button className="bg-gradient-to-br from-green-400/40 via-green-500/30 to-emerald-600/40 text-white px-4 py-2 rounded-md font-semibold hover:opacity-90 transition-all  active:scale-95">
              REQUEST A DEMO
            </button>
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-white text-2xl"
          onClick={() => setMobile(true)}
        >
          ☰
        </button>
      </div>

      {/* Mega Menu */}
      {activeMenu && (
        <div
          className="absolute left-0 top-full w-full bg-[#071104] text-white shadow-2xl"
          onMouseEnter={() => setActive(activeMenu.id)}
          onMouseLeave={() => setActive(null)}
        >
          <div className="max-w-7xl mx-auto px-10 py-14 grid grid-cols-3 gap-12">
            {activeMenu.columns.map((column, i) => (
              <div key={i}>
                <h3 className="text-sky-400 text-sm font-semibold uppercase border-b border-sky-500 pb-2 mb-6">
                  {column.title}
                </h3>
                <div className="space-y-6">
                  {column.items.map((item, j) => (
                    /* Wrap the item in an anchor tag */
                    <a 
                      key={j} 
                      href={item.url || "#"} 
                      className="block group hover:bg-white/5 p-2 -ml-2 rounded-lg transition-colors"
                    >
                      <h4 className="font-semibold text-white group-hover:text-sky-400 transition-colors">
                        {item.title}
                      </h4>
                      {item.description && (
                        <p className="text-sm text-white/70">
                          {item.description}
                        </p>
                      )}
                    </a>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {activeMenu.cta && (
            <div className="mt-12 text-center pb-10">
              <a
                href={activeMenu.cta.url}
                className="inline-block bg-orange-500 hover:bg-orange-600 px-6 py-3 font-semibold text-white"
              >
                {activeMenu.cta.text}
              </a>
            </div>
          )}
        </div>
      )}

      {/* Mobile Menu */}
      {mobile && <MobileMenu menus={menus} close={() => setMobile(false)} />}
    </nav>
  );
}
